module.exports = __webpack_public_path__ + "static/media/Red.5a9f44ba.svg";